import { useEsiteCtx } from 'services/esite/context';
import { getIsMapHidden } from 'components/pcc-components';

export const useHideMaps = () => {
  const { userCountryCode, dealerCode } = useEsiteCtx();
  const isHidingMaps = getIsMapHidden({ userCountryCode, dealerCode });
  return { isHidingMaps, userCountryCode, dealerCode };
};
